import eulaText from './assets/fedex-standard-eula.en.txt?raw';

export const FEDEX_STANDARD_EULA_TEXT = eulaText;

export const FEDEX_EULA_ACCEPT_BUTTON_LABEL =
    'I accept the terms of FedEx EULA to start shipping';

export const FEDEX_EULA_ACKNOWLEDGMENT_LABEL =
    'I have read the FedEx End User License Agreement';
